import api, { webApi, getCsrfToken } from "../api";

export function getProjects() {
  return api.get(`/projects`);
}

export function getProject(id: string | number) {
  return api.get(`/projects/${id}`);
}

export async function createProject(payload: any) {
  await getCsrfToken();
  return webApi.post(`/admin/projects`, payload);
}

export async function updateProject(id: string | number, payload: any) {
  await getCsrfToken();
  return webApi.put(`/admin/projects/${id}`, payload);
}

export async function deleteProject(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/projects/${id}`);
}

export async function uploadProjectImage(
  id: string | number,
  formData: FormData
) {
  await getCsrfToken();
  return webApi.post(`/admin/projects/${id}/images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export default {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  uploadProjectImage,
};
